import { useBrand } from '@/hooks/useBrand';
import { useAuth } from '@/hooks/useAuth';

/**
 * Shows an access-denied message when a logged-in user is on a custom domain
 * but doesn't have access to that domain's brand.
 * Returns null (renders children) when there's no mismatch.
 */
export function DomainGate({ children }: { children: React.ReactNode }) {
  const { user } = useAuth();
  const { isDomainMismatch, isLoading } = useBrand();

  // Only gate authenticated users after brands have loaded
  if (!user || isLoading || !isDomainMismatch) {
    return <>{children}</>;
  }

  return (
    <div className="flex min-h-screen items-center justify-center bg-background p-6">
      <div className="max-w-md text-center space-y-4">
        <h1 className="text-2xl font-semibold">Access Denied</h1>
        <p className="text-muted-foreground">
          You don't have access to this workspace. Contact your administrator to
          request access, or sign in with a different account.
        </p>
        <p className="text-sm text-muted-foreground">
          Domain: {window.location.hostname}
        </p>
      </div>
    </div>
  );
}
